import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { DatepickerService } from './datepicker.service';
import { FormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { DatePicker, DatePickerModule } from 'primeng/datepicker';

@Component({
    selector: 'app-datepicker-calendar',
    templateUrl: './datepicker-calendar.component.html',
    styleUrl: './datepicker-calendar.component.scss',
    imports: [DatePickerModule, MatButtonModule, MatDividerModule, FormsModule, DatePipe, CommonModule, MatIcon]
})
export class DatepickerCalendarComponent {
    @ViewChild('myCalendar') datePicker!: DatePicker;
    @Input () isDateRange:boolean=true;
    @Input() dateRange!:Date[];
    @Input() date!:Date;
    @Output() dateChange: EventEmitter<boolean> = new EventEmitter();
    @ViewChild('btnRef') buttonRef!: MatButton;
    previousDate! : Date;
    previousDateRange! :Date[];
  constructor(public datepickerService:DatepickerService){
  }
  setDateChange(){
    this.datepickerService.reportDate = this.date;
    this.datepickerService.dateRange = this.dateRange;
    this.dateChange.emit(this.isDateRange);
    this.previousDate = this.date;
    this.previousDateRange = this.dateRange;
   }

   ngAfterViewInit() {
    this.previousDate = this.date;
    this.previousDateRange = this.dateRange;
    if(this.buttonRef != undefined){
    this.buttonRef.focus();
    }   
  }

  clearCalendar(){
    this.dateRange = this.previousDateRange;
    this.date = this.previousDate;
  }

}
